(function() {
  'use strict';

  var rootSelector = '[data-cart-gift-wrap]';
  var checkboxSelector = '[data-cart-gift-wrap-checkbox]';
  var noteSelector = '[data-cart-gift-wrap-note]';
  var propertyName = '_cart_gift_wrap';
  var giftNoteVariantId = '54645881995539';
  var giftNoteOwnerAttribute = 'gift_note_variant__';
  var legacySeparateAttribute = 'Wrap items separately';
  var noteTimer = null;
  var noteDraft = null;
  var noteSaveRevision = 0;
  var hadGiftNoteItem = document.querySelector(noteSelector) !== null;

  function getRoots() {
    return Array.prototype.slice.call(document.querySelectorAll(rootSelector));
  }

  function getRoute(name, fallback) {
    return window.theme && theme.routes && theme.routes[name] ? theme.routes[name] : fallback;
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function request(url, options) {
    return fetch(url, options).then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok || data.status === 422) {
          var error = new Error(data.description || data.message || 'Cart request failed');
          error.data = data;
          error.status = data.status || response.status;
          throw error;
        }
        return data;
      });
    });
  }

  function fetchCart() {
    return request(getRoute('cart', '/cart.js'), {
      method: 'GET',
      headers: { Accept: 'application/json' }
    });
  }

  function giftWrapItems(cart, variantId) {
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items.filter(function(item) {
      return String(item.variant_id) === String(variantId) &&
        item.properties && String(item.properties[propertyName]) === 'true';
    });
  }

  function setBusy(root, busy) {
    var checkbox = root.querySelector(checkboxSelector);
    root.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (checkbox) checkbox.disabled = busy;
  }

  function cartHasGiftNoteItem(cart) {
    return Boolean(cart && Array.isArray(cart.items) && cart.items.some(function(item) {
      return String(item.variant_id) === giftNoteVariantId;
    }));
  }

  function setError(root, message) {
    var status = root.querySelector('[data-cart-gift-wrap-status]');
    if (status) status.textContent = message || '';
  }

  function syncRoot(root, cart) {
    var checkbox = root.querySelector(checkboxSelector);
    if (!checkbox) return;

    checkbox.checked = giftWrapItems(cart, root.dataset.variantId).length > 0;
    setBusy(root, false);
  }

  function updateNoteOverflow(note) {
    note.style.overflowY = 'hidden';
    if (note.value && note.scrollHeight > note.clientHeight + 1) {
      note.style.overflowY = 'auto';
    }
  }

  function updateAllNoteOverflows() {
    Array.prototype.slice.call(document.querySelectorAll(noteSelector)).forEach(updateNoteOverflow);
  }

  function syncNoteFields(value, source) {
    Array.prototype.slice.call(document.querySelectorAll(noteSelector)).forEach(function(note) {
      if (note !== source && document.activeElement !== note) note.value = value || '';
      updateNoteOverflow(note);
    });
  }

  function setNoteStatus(message) {
    Array.prototype.slice.call(document.querySelectorAll('[data-cart-gift-note-status]')).forEach(function(status) {
      status.textContent = message || '';
    });
  }

  function normalizeGiftMetadata(cart) {
    var hasGiftNoteItem = cartHasGiftNoteItem(cart);
    var hasLegacySeparateAttribute = cart && cart.attributes && cart.attributes[legacySeparateAttribute];
    var giftNoteOwner = cart && cart.attributes ? cart.attributes[giftNoteOwnerAttribute] : '';
    var payload = {};

    if (hasLegacySeparateAttribute) {
      payload.attributes = {};
      payload.attributes[legacySeparateAttribute] = '';
    }
    if (hasGiftNoteItem && cart && cart.note && String(giftNoteOwner) !== giftNoteVariantId) {
      payload.attributes = payload.attributes || {};
      payload.attributes[giftNoteOwnerAttribute] = giftNoteVariantId;
    }
    if (!hasGiftNoteItem && (String(giftNoteOwner) === giftNoteVariantId || hadGiftNoteItem)) {
      payload.attributes = payload.attributes || {};
      payload.attributes[giftNoteOwnerAttribute] = '';
      if (cart && cart.note) payload.note = '';
    }
    if (!payload.attributes && typeof payload.note === 'undefined') return Promise.resolve(cart);

    return request(shopRoot() + 'cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
  }

  function syncAll(cart) {
    // Cart 02 没有旧版包装/留言控件，不能因临时使用同一商品就启动旧版同步请求。
    if (!getRoots().length && !hadGiftNoteItem && !document.querySelector(noteSelector)) return;
    hadGiftNoteItem = cartHasGiftNoteItem(cart);
    getRoots().forEach(function(root) {
      syncRoot(root, cart);
    });
    if (noteDraft === null) syncNoteFields(cart && cart.note ? cart.note : '');
  }

  function refresh() {
    var roots = getRoots();
    if (!roots.length && !hadGiftNoteItem && !document.querySelector(noteSelector)) return Promise.resolve();

    return fetchCart().then(normalizeGiftMetadata).then(function(cart) {
      syncAll(cart);
      return cart;
    }).catch(function() {
      roots.forEach(function(root) {
        setBusy(root, false);
      });
    });
  }

  function addGiftWrap(root, checkbox) {
    var variantId = Number(root.dataset.variantId);

    return request(getRoute('cartAdd', '/cart/add.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { _cart_gift_wrap: 'true' }
        }]
      })
    }).then(function(data) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: {
          product: data,
          addToCartBtn: checkbox,
          quantity: 1,
          source: 'cart-gift-wrap'
        }
      }));
      if (document.body.classList.contains('template-cart')) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
      return data;
    });
  }

  function removeGiftWrap(root, checkbox) {
    var removedItems = [], removedCurrency;
    return fetchCart().then(function(cart) {
      var items = giftWrapItems(cart, root.dataset.variantId);
      removedCurrency = cart.currency;
      // Share only the confirmed operation's line fields, never gift messages or cart secrets.
      removedItems = items.map(function(item) {
        return { key: item.key, product_id: item.product_id, variant_id: item.variant_id, product_title: item.product_title || item.title,
          price: item.price, final_price: item.final_price, quantity: item.quantity };
      });
      var updates = {};
      items.forEach(function(item) {
        updates[item.key] = 0;
      });

      return request(shopRoot() + 'cart/update.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: updates,
          attributes: {
            'Wrap items separately': '',
            'gift_note_variant__': ''
          },
          note: ''
        })
      });
    }).then(function(cart) {
      syncAll(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: cart, source: 'cart-gift-wrap', trigger: checkbox, removedItems: removedItems, removedCurrency: removedCurrency }
      }));
      document.dispatchEvent(new CustomEvent('cart:build'));
      return cart;
    });
  }

  function saveNote(value) {
    var revision = ++noteSaveRevision;
    var attributes = {};
    attributes[giftNoteOwnerAttribute] = value ? giftNoteVariantId : '';
    setNoteStatus('');

    return request(shopRoot() + 'cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ note: value, attributes: attributes })
    }).then(function(cart) {
      if (revision === noteSaveRevision && noteDraft === value) {
        noteDraft = null;
        syncNoteFields(cart.note || '');
      }
      return cart;
    }).catch(function(error) {
      if (revision === noteSaveRevision) setNoteStatus('Unable to save your gift note. Please try again.');
      throw error;
    });
  }

  function scheduleNoteSave(note, immediate) {
    noteDraft = note.value;
    updateNoteOverflow(note);
    syncNoteFields(noteDraft, note);
    setNoteStatus('');
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function() {
      saveNote(noteDraft).catch(function() {});
    }, immediate ? 0 : 500);
  }

  function onInput(event) {
    var note = event.target.closest(noteSelector);
    if (note) scheduleNoteSave(note, false);
  }

  function onChange(event) {
    var note = event.target.closest(noteSelector);
    if (note) {
      scheduleNoteSave(note, true);
      return;
    }

    var checkbox = event.target.closest(checkboxSelector);
    if (!checkbox) return;

    var root = checkbox.closest(rootSelector);
    if (!root || root.getAttribute('aria-busy') === 'true') return;

    var shouldAdd = checkbox.checked;
    setBusy(root, true);
    setError(root, '');

    var action = shouldAdd ? addGiftWrap(root, checkbox) : removeGiftWrap(root, checkbox);
    action.catch(function(error) {
      checkbox.checked = !shouldAdd;
      setError(root, root.dataset.errorMessage);
      if (shouldAdd) document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: { addToCartBtn: checkbox, source: 'cart-gift-wrap', status: error.status }
      }));
    }).finally(function() {
      setBusy(root, false);
    });
  }

  function scheduleRefresh() {
    window.setTimeout(refresh, 100);
  }

  document.addEventListener('input', onInput);
  document.addEventListener('change', onChange);
  document.addEventListener('ajaxProduct:added', scheduleRefresh);
  document.addEventListener('cart:rendered', scheduleRefresh);
  document.addEventListener('drawerOpen.CartDrawer', scheduleRefresh);
  document.addEventListener('cart:open', scheduleRefresh);
  document.addEventListener('cart:updated', function(event) {
    if (event.detail && event.detail.cart) {
      syncAll(event.detail.cart);
    } else {
      scheduleRefresh();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateAllNoteOverflows();
      refresh();
    });
  } else {
    updateAllNoteOverflows();
    refresh();
  }
})();
